import { render, staticRenderFns } from "./CorrigirDados.vue?vue&type=template&id=79d21690"
import script from "./CorrigirDados.vue?vue&type=script&lang=ts"
export * from "./CorrigirDados.vue?vue&type=script&lang=ts"
import style0 from "./css/main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports